import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_INQ004_Request,
  IAPI_INQ004_Response,
  IAPI_INQ012_Request,
  IAPI_INQ012_Response,
  IAPI_INQ014_Request,
  IAPI_INQ014_Response,
  IAPI_INQ015_Request,
  IAPI_INQ015_Response,
  IAPI_STA035_Request,
  IAPI_STA035_Response,
} from "../../../type/apiType";
import {
  IAPI_STA043_Request,
  IAPI_STA043_Response,
} from "../../../type/apiType/IAPI_STA043";

//職員照会参照
const httpAPI_INQ004 = async (
  param: IAPI_INQ004_Request
): Promise<IAPI_INQ004_Response> => {
  let res = await http.post(ApiUrl.API_INQ004, {
    ...param,
  });

  return res.data;
};

//職員照会問い合わせ更新
const httpAPI_INQ012 = async (
  param: IAPI_INQ012_Request
): Promise<IAPI_INQ012_Response> => {
  let res = await http.post(ApiUrl.API_INQ012, {
    ...param,
  });
  return res.data;
};

//退職手当金追加支給要処理更新
const httpAPI_STA035 = async (
  param: IAPI_STA035_Request
): Promise<IAPI_STA035_Response> => {
  let res = await http.post(ApiUrl.API_STA035, {
    ...param,
  });
  return res.data;
};

//掛金確定後の職員情報の訂正要処理更新
const httpAPI_STA043 = async (
  param: IAPI_STA043_Request
): Promise<IAPI_STA043_Response> => {
  let res = await http.post(ApiUrl.API_STA043, {
    ...param,
  });
  return res.data;
};

//掛金確定後の職員情報の訂正要処理更新
const httpAPI_INQ014 = async (
  param: IAPI_INQ014_Request
): Promise<IAPI_INQ014_Response> => {
  let res = await http.post(ApiUrl.API_INQ014, {
    ...param,
  });
  return res.data;
};

// 照会用コメント更新
const httpAPI_INQ015 = async (
  param: IAPI_INQ015_Request
): Promise<IAPI_INQ015_Response> => {
  let res = await http.post(ApiUrl.API_INQ015, {
    ...param,
  });

  return res.data;
};

export {
  httpAPI_INQ004,
  httpAPI_INQ012,
  httpAPI_STA035,
  httpAPI_STA043,
  httpAPI_INQ014,
  httpAPI_INQ015,
};
